export const addToLocalStorage = (saveItem) => {
	localStorage.setItem("nonAuthAi", saveItem);
};

export const removeFromLocalStorage = () => {
	localStorage.removeItem("nonAuthAi");
};
